import React, { useEffect, useState } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Box, Tab, Tabs } from "@material-ui/core";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@material-ui/core/styles";
import APIMensajeMUI from "componentes/APIMensajeMUI";
import DatosPersonales from "./DatosPersonales";
import CambiarPassword from "./CambiarPassword";
import { errorBackendMsg } from "helpers/helpers";
import { PERMISOS } from "helpers/PermisosConfig";
import axios from "helpers/API";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function SeguridadHub() {
    const theme = useTheme();
    const [value, setValue] = React.useState(0);
    const [keyListaUsuario, setKeyListaUsuario] = React.useState(0);
    const [permisos, setPermisos] = useState([]);
    // API Mensaje
    const [mensajeError, setMensajeError] = useState("");
    const [showError, setShowError] = useState(false);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    useEffect(() => {
        consultarPermisosMenu();
    }, []);

    const peticionBase = ({
        url,
        dataRequest = {},
        hook = false,
        errorHook = false,
    }) => {
        axios
            .post(url, dataRequest)
            .then(function (response) {
                if (response.data.error) {
                    if (Boolean(errorHook)) {
                        errorHook(response.data);
                    } else {
                        setShowError(true);
                        setMensajeError(response.data.msg);
                    }
                } else {
                    if (Boolean(hook)) {
                        hook(response.data);
                    }
                }
            })
            .catch(function (error) {
                setMensajeError(errorBackendMsg(error));
            });
    };

    const consultarPermisosMenu = () => {
        const userData = localStorage.getItem("usuariosData")
            ? JSON.parse(localStorage.getItem("usuariosData"))
            : null;
        const token = userData && userData.token ? userData.token : "";
        if (token === "") {
            return;
        }
        const hook = (data) => {
            setPermisos(data.permisos);
        };
        let peticion = {
            url: "/seguridad/usuarios/permisos/listarMenu",
            hook: hook,
        };
        peticionBase(peticion);
    };

    const hasMenu = (menu) => {
        if (permisos) {
            return (
                permisos.filter((perm) => {
                    return perm.includes(menu);
                }).length > 0
            );
        }
        return false;
    };

    return (
        <>
            <APIMensajeMUI
                mb={30}
                tipo="error"
                showMensaje={showError}
                msg={mensajeError}
            />
            <Grid item md={12}>
                <Card style={{ height: 100, width: "100%" }}>
                    <CardContent>
                        <Typography variant="h5">Mi Cuenta</Typography>
                        {/* <Typography>
                            Revisar y actualizar datos de "Mi Cuenta"
                        </Typography> */}
                    </CardContent>
                </Card>
            </Grid>

            <Tabs
                style={{ marginTop: "2%" }}
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
                aria-label="full width tabs example"
            >
                {hasMenu(PERMISOS.M_MODIFICAR_DATOS_CUENTA) && (
                    <Tab label="Datos Personales" />
                )}
                {hasMenu(PERMISOS.M_MODIFICAR_PASSWORD_CUENTA) && (
                    <Tab label="Cambiar Contraseña" />
                )}
            </Tabs>
            <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={value}
                onChangeIndex={handleChangeIndex}
            >
                {hasMenu(PERMISOS.M_MODIFICAR_DATOS_CUENTA) && (
                    <TabPanel value={value} index={0} dir={theme.direction}>
                        <DatosPersonales
                            key={keyListaUsuario}
                            setKeyLista={setKeyListaUsuario}
                            keyLista={keyListaUsuario}
                        />
                    </TabPanel>
                )}
                {hasMenu(PERMISOS.M_MODIFICAR_PASSWORD_CUENTA) && (
                    <TabPanel value={value} index={1} dir={theme.direction}>
                        <CambiarPassword />
                    </TabPanel>
                )}
            </SwipeableViews>
        </>
    );
}
export default SeguridadHub;
